import { ALL_JOB_SWMS_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

const isToggleEnabled = (value) => {
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    return normalized === "1" || normalized === "true";
  }

  return value === 1 || value === true;
};

const normalizePreStartChecklistPayload = (checklist = {}) => {
  const source = checklist && typeof checklist === "object" ? checklist : {};
  const sourceData = source && source.data && typeof source.data === "object" ? source.data : {};

  return {
    ...source,
    toggle: isToggleEnabled(source.toggle) ? 1 : 0,
    data: {
      ...sourceData,
      pre_start_questions: Array.isArray(sourceData.pre_start_questions) ? sourceData.pre_start_questions : []
    }
  };
};

const resolveErrorMessage = (error) => {
  if (error && error.response && error.response.data && error.response.data.message) {
    return error.response.data.message;
  }

  return Strings.network_error;
};

export const updateJobSwmsPreStartChecklist = (jobId, swmsId, checklistPayload, saveMetadata = {}) => () => {
  if (jobId === undefined || jobId === null || `${jobId}`.trim() === "" || swmsId === undefined || swmsId === null || `${swmsId}`.trim() === "") {
    return Promise.reject(Strings.generic_error);
  }

  const normalizedChecklist = normalizePreStartChecklistPayload(checklistPayload);
  const requestBody = {
    pre_start_checklist: normalizedChecklist,
    ...(saveMetadata.version !== undefined ? { version: saveMetadata.version } : {}),
    ...(saveMetadata.edit_context ? { edit_context: saveMetadata.edit_context } : {})
  };
  const successMessage = "Pre-Start checklist updated successfully.";

  return scopeApiInstance.put(`${ALL_JOB_SWMS_URL}/${jobId}/${swmsId}/pre-start-checklist`, requestBody).then((res) => {
    const responseMessage = res && res.data && res.data.message ? res.data.message : successMessage;
    const responseData = res && res.data && res.data.data ? res.data.data : {};
    const returnedChecklist = responseData && responseData.pre_start_checklist
      ? responseData.pre_start_checklist
      : (res && res.data && res.data.pre_start_checklist ? res.data.pre_start_checklist : normalizedChecklist);

    return Promise.resolve({
      message: responseMessage,
      pre_start_checklist: normalizePreStartChecklistPayload(returnedChecklist)
    });
  }).catch((error) => {
    if (error) {
      return Promise.reject(resolveErrorMessage(error));
    }

    return Promise.reject(null);
  });
};
